import { useQuery } from '@tanstack/react-query';

import { getTimeOffRequestDetails } from '../api/time-offs.api';
import { getTimeOffRequestDetailsQueryKey } from '../constants/time-offs-query-keys';

/** Details rarely change within a session; cache them so rapid open/close of the
 *  same request doesn't refetch on every mount. Mutations invalidate the tree. */
const DETAILS_STALE_TIME = 5000 * 60; // 5 minutes

/**
 * Fetches a single time-off request's details for the read-only details screen.
 * Disabled until a valid numeric id is available.
 */
export const useTimeOffRequestDetails = (requestId: number | undefined) => {
  return useQuery({
    queryKey: getTimeOffRequestDetailsQueryKey(requestId ?? 0),
    queryFn: () => getTimeOffRequestDetails(requestId as number),
    enabled: typeof requestId === 'number' && !Number.isNaN(requestId),
    staleTime: DETAILS_STALE_TIME,
  });
};
